
(function () {
  const grid       = document.getElementById('workGrid');
  const filtersBtn  = document.getElementById('workFiltersBtn');
  const filtersPanel = document.getElementById('workFiltersPanel');
  if (!grid) return;

  let allProjects = [];
  const selectedTags = new Set();
  const isEs = location.pathname.startsWith('/es/');
  const projectHref = (slug) => (isEs ? `/es/proyecto/${slug}/` : `/work/${slug}/`);

  function cardHTML(p) {
    const tags = p.tags.map(t => `<span>${t}</span>`).join('');
    const variantClass = p.variant ? ` work-card--${p.variant}` : '';
    return `
      <a class="work-card${variantClass}" href="${projectHref(p.slug)}" data-slug="${p.slug}">
        <div class="work-card__img-wrap">
          <img src="${p.cover_image}" alt="${p.name}" class="work-card__img" loading="lazy" />
        </div>
        <div class="work-card__meta">
          <p class="work-card__name">${p.name}</p>
          <p class="work-card__subtitle">${p.subtitle}</p>
          <div class="work-card__tags">${tags}</div>
        </div>
      </a>`;
  }

  function renderGrid(projects) {
    grid.innerHTML = '';
    grid.removeAttribute('aria-busy');

    if (!projects.length) {
      grid.innerHTML = '<p class="work-grid__error">No projects match these filters.</p>';
      return;
    }

    let i = 0;
    while (i < projects.length) {
      const full = document.createElement('div');
      full.className = 'work-row work-row--full';
      full.innerHTML = cardHTML(projects[i]);
      grid.appendChild(full);
      i += 1;

      if (i < projects.length) {
        const a = projects[i];
        const b = projects[i + 1];
        const row = document.createElement('div');
        row.className = 'work-row work-row--half' + (b ? '' : ' work-row--orphan');
        row.innerHTML = cardHTML(a) + (b ? cardHTML(b) : '');
        grid.appendChild(row);
        i += b ? 2 : 1;
      }
    }
  }

  function applyFilters() {
    const filtered = selectedTags.size === 0
      ? allProjects
      : allProjects.filter(p => p.tags.some(t => selectedTags.has(t)));
    renderGrid(filtered);
  }

  function buildTagList(projects) {
    
    const tags = [...new Set(projects.flatMap(p => p.tags))].sort((a, b) => a.localeCompare(b));

    if (!filtersPanel) return;

    if (!tags.length) {
      filtersPanel.innerHTML = '<p class="work-filters__empty">No tags yet.</p>';
      return;
    }

    filtersPanel.innerHTML = `
      <div class="work-filters__list">
        ${tags.map(t => `<button type="button" class="work-filters__tag" data-tag="${t}">${t}</button>`).join('')}
      </div>
      <button type="button" class="work-filters__clear" id="workFiltersClear">Clear filters</button>
    `;

    filtersPanel.querySelectorAll('.work-filters__tag').forEach(btn => {
      btn.addEventListener('click', () => {
        const tag = btn.dataset.tag;
        if (selectedTags.has(tag)) {
          selectedTags.delete(tag);
          btn.classList.remove('is-active');
        } else {
          selectedTags.add(tag);
          btn.classList.add('is-active');
        }
        updateFiltersBtnState();
        applyFilters();
      });
    });

    const clearBtn = document.getElementById('workFiltersClear');
    clearBtn?.addEventListener('click', () => {
      selectedTags.clear();
      filtersPanel.querySelectorAll('.work-filters__tag.is-active').forEach(b => b.classList.remove('is-active'));
      updateFiltersBtnState();
      applyFilters();
    });
  }

  function updateFiltersBtnState() {
    filtersBtn?.classList.toggle('is-active', selectedTags.size > 0);
  }

  if (filtersBtn) {
    filtersBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      const isOpen = filtersBtn.getAttribute('aria-expanded') === 'true';
      filtersBtn.setAttribute('aria-expanded', String(!isOpen));
      filtersPanel?.classList.toggle('is-open', !isOpen);
    });

    document.addEventListener('click', (e) => {
      if (!e.target.closest('#workFilters')) {
        filtersBtn.setAttribute('aria-expanded', 'false');
        filtersPanel?.classList.remove('is-open');
      }
    });
  }

  fetch(`/api/projects?lang=${isEs ? 'es' : 'en'}`)
    .then(r => r.json())
    .then(projects => {
      allProjects = projects;
      buildTagList(projects);
      renderGrid(projects);
    })
    .catch(err => {
      console.error('No se pudieron cargar los proyectos:', err);
      grid.removeAttribute('aria-busy');
      grid.innerHTML = '<p class="work-grid__error">No se han podido cargar los proyectos.</p>';
    });
})();
